import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { ThemeProvider } from '@mui/material/styles'
import { theme } from './brand/theme'
import CssBaseline from '@mui/material/CssBaseline'
import App from './App.tsx'
import './i18n'
import './styles/fonts.scss'
import './styles/_tokens.generated.scss'
import './brand/brand.scss'
import './brand/motion.scss'
import './brand/model.scss'
import './styles/globals.scss'
import { reportWebVitals } from './utils/web-vitals'

// Tema da marca (F6): src/brand/theme.ts lê a MESMA fonte que o SCSS (src/brand/tokens.ts) — ADR-001/009/013

// Renderização otimizada para SEO:
// 1. HelmetProvider garante que meta tags sejam aplicadas imediatamente
// 2. Meta tags do index.html servem como fallback para crawlers
// 3. SEOHead atualiza dinamicamente quando o JS carrega
// 4. Isso garante SEO mesmo sem JavaScript (crawlers) e melhor UX (usuários)
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      {/* defaultMode fixo: o chão do documento é tinta (D25) e NÃO segue o modo escuro/claro do sistema — o MUI marcaria <html data-surface> pela preferência do SO */}
      <ThemeProvider theme={theme} defaultMode="dark">
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>,
)

// Core Web Vitals → GA4 (docs/analytics-events.md). Service Worker desligado na F4 (public/sw.js é kill-switch).
if (typeof window !== 'undefined') {
  reportWebVitals()
}
